import axios from "axios";
import router from '@/router/index';
import { Loading } from 'element-ui';
import { Message } from 'element-ui';
// axios.headers["Content-Type"] = "application/json"
let loadingInstance;
const service = axios.create({
  //请求超时时间
  //timeout: 800,
  responseType: "json", // 响应数据格式
  responseEncoding: "utf-8", // 响应数据编码 
  // baseURL: "https://zhaopintest.xuruidea.com/api",   // 测试服
  baseURL: "https://zhaopin.xuruidea.com/api"   // 正式服



  // baseURL:"/api",


  // baseURL:process.env.VUE_APP_BASE_API

  // baseURL:'http://recruit.xuruidea.com'


});
// let baseURLStr = 'https://recruit.xuruidea.com'
// if(process.env.NODE_ENV=='development'){
//   service.defaults.baseURL = process.env.VUE_APP_BASEURL
// }else if(process.env.NODE_ENV=='production'){
//   service.defaults.baseURL = baseURLStr
// }
service.interceptors.request.use(
  config => {

    // console.log('dddd')
    // console.log(process.env.NODE_ENV)
    // console.log('aaa')
    // console.log(config.url)
    // if(process.env.NODE_ENV=='production'){
    //   config.url = baseURLStr + config.url.split(/\/api\//)[1]
    //   console.log('config')
    //   console.log(config.url)
    // }
    // console.log('cccc')
    // console.log(config.url)
    loadingInstance = Loading.service({ fullscreen: true, text: "拼命加载中" });

    if (config.url == '/') { //如果是登录，则不需要携带header里面的token
    } else {
      if (sessionStorage.getItem('token')) {
        config.headers["token"] = sessionStorage.getItem('token');
        // publicVue.userInfo = JSON.parse(sessionStorage.getItem('userInfo'))
      }
      // else{
      //     router.push({
      //       path:'/'
      //     })
      // }
    }

    return config;
  },
  error => {
    return Promise.reject(error)
  }
);

//响应拦截器
//异步请求后，判断token是否过期
// window.tipLock = false;
service.interceptors.response.use(
  response => {
    // console.log('response')
    // console.log(response)
    if (!sessionStorage.getItem('token') || response.data.code == 401) {
      if (response.data.code == 401) {
        sessionStorage.removeItem('token')
        Message.warning({
          message: response.data.message,
          duration: 2000
        })
      }
      router.push({
        name: 'Login'
      }).catch((e) => {

      })
    }
    // console.log(response)

    if (response.status == 200) {
      // this.$nextTick(() => { // 以服务的方式调用的 Loading 需要异步关闭

      loadingInstance.close();
      // });
      return response.data
    }

    // return response;
    // return response;
  },
  error => {
    return Promise.reject(error)
    // if (error.response) {
    //   switch (error.response.status) {
    //     case 401:
    //       sessionStorage.removeItem('Authorization');
    //       this.$router.push('/');
    //   }
    // }
  }
);

// 封装post请求
export function axiosPost(url, data, head = '') {
  return new Promise((resolve, reject) => {
    service.post(url, data, head).then((response) => {
      resolve(response)
    }).catch((error) => {
      reject(error)
      console.error('error', error)
    })
  })
}

// 封装get请求
export function axiosGet(url, data, head = '') {
  return new Promise((resolve, reject) => {
    service.get(url, data, head).then((response) => {
      resolve(response)
    }).catch((error) => {
      reject(error)
      console.error('error', error)
    })
  })
}


// export default service
